// extracted by mini-css-extract-plugin
export default {"container":"styles_container__oEx2+","smallImg":"styles_smallImg__pC1Bb","bigImg":"styles_bigImg__N1uwf"};